import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("bdi", {
    class: _normalizeClass($props.className)
  }, _toDisplayString($setup.formattedPrice), 3 /* TEXT, CLASS */))
}